<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <el-row type="flex" justify="space-between">
        <div class="top-filter">
          <el-form
            ref="filterForm"
            :inline="true"
            :model="filterForm"
            class="filter-form"
          >
            <el-form-item prop="name">
              <el-input v-model="filterForm.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleFilterDict"
                >查询</el-button
              >
              <el-button
                type="primary"
                plain
                @click="handleResetFilter('filterForm')"
              >
                <i class="el-icon-refresh-right"></i>清空
              </el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-panle">
          <el-button @click="handleAddDict" type="primary" icon="el-icon-plus">
            添加
          </el-button>
        </div>
      </el-row>
    </div>
    <div class="main">
      <el-table
        :data="dicts"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="pagination.loading"
      >
        <el-table-column label="编码" prop="code" align="center">
        </el-table-column>
        <el-table-column label="字典名称" prop="name" align="center">
        </el-table-column>
        <el-table-column label="状态" prop="disable" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.disable == 0">正常</el-tag>
            <el-tag v-if="row.disable == 1" type="danger">停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" align="center">
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="240">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleLookDictData(row)">
              字典数据
            </el-button>
            <el-button
              type="text"
              @click="changeDictStatus(row)"
              v-if="row.disable == 1"
            >
              启用
            </el-button>
            <el-button
              type="text"
              @click="changeDictStatus(row)"
              v-if="row.disable == 0"
            >
              停用
            </el-button>
            <el-button type="text" @click="handleUpdateDict(row)">
              修改
            </el-button>
            <el-button type="text" @click="handleRemoveDict(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 添加和更新弹框 -->
    <el-dialog
      class="dialog-bg"
      :title="addOrUpdateDict.title"
      :visible.sync="addOrUpdateDict.dialogShow"
      @close="onAddDictDialogClosed"
      width="430px"
    >
      <el-form
        ref="addForm"
        :model="addOrUpdateDict.model"
        :rules="addOrUpdateDict.rules"
        label-width="100px"
        v-loading="addOrUpdateDict.loading"
      >
        <el-form-item prop="name" label="字典名称">
          <el-input
            v-model="addOrUpdateDict.model.name"
            placeholder="字典名称"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code" label="字典编码">
          <el-input
            v-model="addOrUpdateDict.model.code"
            placeholder="字典编码"
            style="width: 280px"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item prop="orderNum" label="显示排序">
          <el-input-number
            v-model="addOrUpdateDict.model.orderNum"
            style="width: 280px"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item prop="disable" label="状态">
          <el-radio-group v-model="addOrUpdateDict.model.disable">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            v-model="addOrUpdateDict.model.remark"
            placeholder="备注"
            style="width: 280px"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="addDictConfirm"
          v-if="handleType === 'add'"
        >
          确 定
        </el-button>
        <el-button
          type="primary"
          @click="editDictConfirm"
          v-if="handleType === 'edit'"
        >
          确 定
        </el-button>
        <el-button @click="addOrUpdateDict.dialogShow = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 删除字典弹窗 -->
    <el-dialog
      class="dialog-bg dialog-remove"
      title="删除字典"
      :visible.sync="dialogRemoveVisible"
      width="480px"
    >
      <div class="tip"><i class="el-icon-warning"></i>请谨慎操作</div>
      <div class="con">
        此操作将永久删除字典<span>{{ removeName }}</span
        >, 是否继续?
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRemoveVisible = false">取消</el-button>
        <el-button type="primary" @click="handleRemoveDictConfirm">
          删除
        </el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
export default {
  name: 'DictManagement',
  data() {
    return {
      filterForm: {
        name: '', // 人员姓名
      },
      dicts: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
        loading: false,
      },
      handleType: 'add',
      dialogRemoveVisible: false,
      removeName: '',
      rowId: '',
      addOrUpdateDict: {
        dialogShow: false,
        title: '添加字典',
        loading: false,
        model: {
          name: '',
          parentId: 0,
          code: '',
          level: 0,
          disable: 0,
          remark: '',
          orderNum: 0,
        },
        rules: {
          name: [
            { required: true, message: '请输入字典名称', trigger: 'blur' },
          ],
          code: [
            { required: true, message: '请输入字典编码', trigger: 'blur' },
            {
              pattern: /^[0-9A-Za-z]{0,20}$/g,
              message: '字典编码为数字或字母，最大长度为20位',
              trigger: 'change',
            },
          ],
        },
      }, //添加和修改字典配置
    }
  },
  async mounted() {
    this.getDictList()
  },
  methods: {
    /**
     * @description: 查询字典
     * @Author: quwandong
     * @Date: 2022-05-30 15:26:45
     */
    handleFilterDict() {
      this.pagination.currentPage = 1
      this.getDictList()
    },
    /**
     * @description: 重置 搜索条件
     * @param {*} formName 表单ref
     * @Author: quwandong
     * @Date: 2022-05-30 15:37:44
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.getDictList()
    },
    /**
     * @description: 获取字典列表
     * @Author: quwandong
     * @Date: 2022-05-30 15:54:01
     */
    async getDictList() {
      try {
        this.pagination.loading = true
        const { currentPage, pageSize } = this.pagination
        const params = { currentPage, pageSize, name: this.filterForm.name }

        const res = await this.$http.dict.getDictList(params)
        const { recordTotal, content: dicts } = res.data
        this.pagination.recordTotal = recordTotal
        this.dicts = dicts
      } catch (error) {
        this.$message.error('获取失败')
      } finally {
        this.pagination.loading = false
      }
    },
    /**
     * @description:  修改页码
     * @param {*} val 当前页码
     * @Author: quwandong
     * @Date: 2022-05-30 15:55:48
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getDictList()
    },
    /**
     * @descripttion: 添加字典
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    handleAddDict() {
      this.addOrUpdateDict.dialogShow = true
      this.addOrUpdateDict.title = '添加字典'
      this.handleType = 'add'
      this.addOrUpdateDict.model = {
        name: '',
        parentId: 0,
        code: '',
        level: 0,
        disable: 0,
        remark: '',
        orderNum: 0,
      }
    },
    /**
     * @descripttion: 添加字典确认
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    addDictConfirm() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            this.addOrUpdateDict.loading = true
            const { name, parentId, code, level, remark, orderNum } =
              this.addOrUpdateDict.model
            const params = {
              name,
              parentId,
              code,
              orderNum,
              level,
              remark,
            }
            await this.$http.dict.insertDict(params)

            this.$message.success('添加成功')
            this.getDictList()
            this.addOrUpdateDict.dialogShow = false
          } catch (error) {
            this.$message.error(error.message || '添加失败')
          } finally {
            this.addOrUpdateDict.loading = false
          }
        }
      })
    },
    /**
     * @descripttion: 添加字典弹框关闭事件
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    onAddDictDialogClosed() {
      this.$refs.addForm.resetFields()
    },
    /**
     * @description: 查看字典数据
     * @param {*} row 当前数据
     * @Author: quwandong
     * @Date: 2022-05-30 16:00:06
     */
    handleLookDictData(row) {
      this.$router.push({
        path: '/setting/dict-management/data',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },
    /**
     * @description: 修改字典状态
     * @param {*} row 当前数据
     * @Author: quwandong
     * @Date: 2022-05-30 16:00:06
     */
    changeDictStatus(row) {
      const type = row.disable == 1 ? '启用' : '停用'
      const msg = `是否确认${type}字典“${row.name}”?`
      const status = row.disable == 1 ? 0 : 1

      this.$confirm(msg, `${type}提示`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await this.$http.dict.updatDict({
            id: row.id,
            disable: status,
          })

          this.$message.success(`${type}成功`)
          this.getDictList()
        })
        .catch(() => {})
    },
    /**
     * @description: 修改字典
     * @param {*} item
     * @Author: quwandong
     * @Date: 2022-05-30 16:07:59
     */
    handleUpdateDict(row) {
      this.addOrUpdateDict.dialogShow = true
      this.addOrUpdateDict.title = '修改字典'
      this.addOrUpdateDict.model = { ...row }
      this.handleType = 'edit'
    },
    /**
     * @description: 修改字典确认操作
     * @Author: quwandong
     * @Date: 2022-05-30 17:49:31
     */
    async editDictConfirm() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          try {
            this.addOrUpdateDict.loading = true
            const { name, parentId, code, level, remark, id, orderNum } =
              this.addOrUpdateDict.model
            const params = {
              id,
              name,
              parentId,
              code,
              orderNum,
              level,
              remark,
            }
            await this.$http.dict.updatDict(params)

            this.$message.success('修改成功')
            this.getDictList()
            this.addOrUpdateDict.dialogShow = false
          } catch (error) {
            this.$message.error(error.message || '修改失败')
          } finally {
            this.addOrUpdateDict.loading = false
          }
        }
      })
    },
    /**
     * @description: 删除字典
     * @Author: quwandong
     * @Date: 2022-05-30 17:49:31
     */
    handleRemoveDict(row) {
      this.removeName = row.name
      this.rowId = row.id
      this.dialogRemoveVisible = true
    },
    async handleRemoveDictConfirm() {
      try {
        await this.$http.dict.removeDict({
          id: this.rowId,
        })

        this.$message.success('删除成功')
        this.dialogRemoveVisible = false
        this.getDictList()
      } catch (error) {
        this.$message.error(error.message || '删除失败')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .top-filter {
    display: flex;
    justify-content: space-between;
  }
  .btn-panle {
    margin-top: 6px;
    margin-bottom: 12px;
  }
  .el-table {
    .tag {
      color: #ff0000;
    }
    .el-button {
      padding: 5px 0;
    }
  }
}
::v-deep {
  .dict-edit-dialog .el-dialog__body {
    padding: 0;
  }
  .el-dialog {
    .el-form-item {
      margin-bottom: 26px !important;
    }
    .el-dialog__footer {
      padding-top: 0;
      text-align: center;
    }
  }
  .dialog-info {
    .el-dialog__body {
      padding: 10px 20px;
      .tip {
        color: #018388;
        margin-bottom: 10px;
        i {
          margin-right: 5px;
        }
      }
      .el-form {
        margin: 0 30px;
        .el-form-item {
          margin-bottom: 26px;
          &:first-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .dialog-password {
    .el-dialog__body {
      padding: 10px 20px;
      .tip {
        color: #018388;
        margin-bottom: 10px;
        i {
          margin-right: 5px;
        }
      }
      .el-form {
        .el-form-item {
          &:first-child {
            margin-bottom: 0;
            .el-form-item__label,
            .el-form-item__content {
              line-height: 20px;
            }
          }
          &:nth-child(2) {
            margin-bottom: 0;
          }
          .tips {
            font-size: 14px;
            line-height: 20px;
            color: #acacac;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dialog-remove {
  .el-dialog__header {
    padding: 0;
    text-align: center;
    .el-dialog__title {
      font-size: 22px;
      color: #242424;
      font-weight: 400;
    }
  }
  .el-dialog__body {
    padding: 20px 0;
    .title {
      font-size: 22px;
      color: #242424;
      text-align: center;
    }
    .tip {
      display: flex;
      align-items: center;
      height: 35px;
      padding: 0 23px;
      color: #ff8400;
      background-color: #fff7ef;
      .el-icon-warning {
        margin-right: 5px;
      }
    }
    .con {
      padding: 20px 50px;
      font-size: 20px;
      color: #444444;
      span {
        color: #018388;
      }
    }
  }
}
</style>
